export const activeRoute = ({
  routeName,
  exact,
  pathname,
  selectedAcceptedRoute,
}: {
  routeName: string;
  pathname: string;
  exact?: boolean;
  selectedAcceptedRoute?: string;
}) => {
  if (
    selectedAcceptedRoute !== undefined &&
    pathname.includes(selectedAcceptedRoute)
  ) {
    return true;
  }
  if (exact) {
    return pathname === routeName;
  } else {
    return pathname.includes(routeName);
  }
};
